import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'
import { compose } from 'redux'

import {  BigCalendarBase } from './BigCalendar'

import { routeIdSelector } from 'reduxModules/selectors/RouteSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  routeId: routeIdSelector,
})

const enhance = compose(
  connect(mapStateToProps),
  withStyles(styles)
)

export const BigCalendar = enhance(BigCalendarBase)


// WEBPACK FOOTER //
// ./src/components/BigCalendar/index.js